import { getApiUrl } from '../config';

export class ApiError extends Error {
  status: number;
  data: any;

  constructor(message: string, status: number, data: any) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.data = data;
  }
}

type ApiFetchOptions = Omit<RequestInit, 'credentials'> & {
  json?: any;
};

// Token 管理
export function getToken(): string | null {
  return localStorage.getItem('auth_token');
}

export function setToken(token: string): void {
  localStorage.setItem('auth_token', token);
}

export function clearToken(): void {
  localStorage.removeItem('auth_token');
}

export async function apiFetch<T>(input: RequestInfo | URL, options: ApiFetchOptions = {}): Promise<T> {
  const { json, headers, ...rest } = options;

  // 转换相对路径为完整 URL
  const url = typeof input === 'string' ? getApiUrl(input) : input;

  // 获取 token
  const token = getToken();

  const init: RequestInit = {
    ...rest,
    headers: {
      ...(json ? { 'Content-Type': 'application/json' } : {}),
      ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
      ...(headers || {})
    }
  };

  if (typeof json !== 'undefined') {
    init.body = JSON.stringify(json);
  }

  const res = await fetch(url, init);
  const contentType = res.headers.get('content-type') || '';

  let data: any = null;
  if (contentType.includes('application/json')) {
    data = await res.json().catch(() => null);
  } else {
    data = await res.text().catch(() => null);
  }

  if (!res.ok) {
    const msg = data && typeof data === 'object' && 'error' in data ? String((data as any).error) : `request failed (${res.status})`;
    throw new ApiError(msg, res.status, data);
  }

  return data as T;
}
